import { api } from './client';

export interface OtherPayoutDto {
  id: number;
  personId: number;
  personName: string;
  journalEntryId: number;
  entryDate: string;
  incomeCode: string;
  suma: number;
  sumaBruto: number;
  rate: number;
  remarks: string | null;
  grossForDeclaration: number;
  taxForDeclaration: number;
}

export interface ClassBPayoutDto {
  id: number;
  personId: number;
  personName: string;
  journalEntryId: number;
  amount: number;
  taxCode: string;
  taxPayedOutDate: string | null;
  taxDeductedAndPayed: number;
  taxPayedByCompany: number;
  remarks: string | null;
}

export interface JournalEntryPickDto {
  id: number;
  date: string;
  documentNumber: string;
  content: string;
  amount: number;
}

export const otherPayoutsApi = {
  listOther: () => api.get<OtherPayoutDto[]>('/payroll/payouts/other'),
  listClassB: () => api.get<ClassBPayoutDto[]>('/payroll/payouts/class-b'),
  pickEntries: (personId: number) =>
    api.get<JournalEntryPickDto[]>(`/payroll/payouts/journal-entries/${personId}`),

  saveOther: (body: { id?: number | null; personId: number; journalEntryId: number; incomeCode: string; suma: number; sumaBruto: number; rate: number; remarks?: string | null }) =>
    api.post<number>('/payroll/payouts/other', body),

  saveClassB: (body: { id?: number | null; personId: number; journalEntryId: number; amount: number; taxCode: string; taxPayedOutDate?: string | null; taxDeductedAndPayed: number; taxPayedByCompany: number; remarks?: string | null }) =>
    api.post<number>('/payroll/payouts/class-b', body),

  deleteOther: (id: number) => api.delete<void>(`/payroll/payouts/other/${id}`),
  deleteClassB: (id: number) => api.delete<void>(`/payroll/payouts/class-b/${id}`),
};
